__webpack_require__.p = "/vending-machine/";